import LoginForm from '../Auth/LoginForm';
export default function CartLoginForm() { return <LoginForm destination="/auth/checkout" />; }
